import AutoRenewals from '../../../views/practice/autorenewals/AutoRenewals';

const autoRenewalsRoutes = [
  {
    path: '/practice/auto-renewals',
    element: <AutoRenewals />
  }
];

export default autoRenewalsRoutes;
